import { connect } from "react-redux";

import { AsyncForm as Presenter, AsyncFormStateProps, AsyncFormOwnProps } from "./presenter";
import { ApiState } from "../../models/state";
import { getAllRequests } from "../../selectors";

// Map the api state to the component.
function mapStateToProps(state: ApiState) {
    return {
        requests: getAllRequests(state),
    } as AsyncFormStateProps;
}

function mergeProps(stateProps: AsyncFormStateProps, dispatchProps: {}, ownProps: AsyncFormOwnProps) {
  return Object.assign({}, ownProps, stateProps, dispatchProps);
}

// Connect the component to Redux.
const AsyncForm = connect(mapStateToProps, null, mergeProps)(Presenter);

export { AsyncForm };
